import React, {useEffect, useState} from 'react';
import axios from 'axios';
import '../assets/css/BexioUpdates.css';
import {API_BASE_URL} from '../config';

const SYNC_ITEMS = [
    { key: 'customers',           name: 'Clients',           icon: 'fa-users',         url: (base) => `${base}/bexio/get_customers_relations/get_customers` },
    { key: 'orders',              name: 'Commandes',         icon: 'fa-file-contract', url: (base) => `${base}/bexio/get_orders` },
    { key: 'positions',           name: 'Projets',           icon: 'fa-diagram-project',url: (base) => `${base}/bexio/get_positions` },
    { key: 'articles',            name: 'Produits',          icon: 'fa-box',           url: (base) => `${base}/bexio/get_articles` },
    { key: 'invoices',            name: 'Factures',          icon: 'fa-file-invoice',  url: (base) => `${base}/bexio/get_invoices` },
    { key: 'customers_relations', name: 'Relations clients', icon: 'fa-link',          url: (base) => `${base}/bexio/get_customers_relations` },
    { key: 'sectors',             name: 'Secteurs',          icon: 'fa-tag',           url: (base) => `${base}/bexio/get_sectors` },
];

const BexioUpdate = () => {
    const [itemStates, setItemStates]     = useState({});
    const [syncProgress, setSyncProgress] = useState(null);
    const [globalMessage, setGlobalMessage] = useState(null);

    useEffect(() => {
        document.title = 'Mettre à jour Bexio';
    }, []);

    const runSingle = async (item) => {
        if (syncProgress?.active) return;
        setItemStates(prev => ({ ...prev, [item.key]: 'loading' }));
        setGlobalMessage(null);
        try {
            await axios.get(item.url(API_BASE_URL));
            setItemStates(prev => ({ ...prev, [item.key]: 'ok' }));
        } catch {
            setItemStates(prev => ({ ...prev, [item.key]: 'error' }));
        }
    };

    const runAll = async () => {
        setGlobalMessage(null);
        setItemStates({});
        setSyncProgress({ active: true, completed: 0, total: SYNC_ITEMS.length, currentName: SYNC_ITEMS[0].name });

        for (let i = 0; i < SYNC_ITEMS.length; i++) {
            const item = SYNC_ITEMS[i];
            setSyncProgress(prev => ({ ...prev, currentName: item.name, completed: i }));
            setItemStates(prev => ({ ...prev, [item.key]: 'loading' }));
            try {
                await axios.get(item.url(API_BASE_URL));
                setItemStates(prev => ({ ...prev, [item.key]: 'ok' }));
            } catch {
                setItemStates(prev => ({ ...prev, [item.key]: 'error' }));
            }
        }

        setSyncProgress({ active: false, completed: SYNC_ITEMS.length, total: SYNC_ITEMS.length, currentName: null });
        setGlobalMessage('Synchronisation complète terminée avec succès.');
    };

    const isSyncRunning = !!syncProgress?.active;
    const percent = syncProgress ? Math.round((syncProgress.completed / syncProgress.total) * 100) : 0;

    return (
        <div>
            <h2>Mise à jour des données Bexio</h2>

            <div className="container p-20 shadow" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                {/* Info + action */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '14px', color: '#475569' }}>
                        <i className="fa-regular fa-circle-info" style={{ marginTop: '3px', color: '#3b82f6', flexShrink: 0 }} />
                        <div>
                            Synchronisation automatique toutes les <strong>30 minutes</strong>.<br />
                            <span style={{ color: '#94a3b8' }}>Cliquez sur un bloc pour une mise à jour ciblée, ou lancez tout d'un coup.</span>
                        </div>
                    </div>

                    <button
                        onClick={runAll}
                        disabled={isSyncRunning}
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                            padding: '10px 20px',
                            background: isSyncRunning ? '#94a3b8' : '#3b82f6',
                            color: '#fff',
                            border: 'none', borderRadius: '8px',
                            fontSize: '14px', fontWeight: 600,
                            cursor: isSyncRunning ? 'not-allowed' : 'pointer',
                            whiteSpace: 'nowrap',
                            transition: 'background 0.2s',
                            flexShrink: 0
                        }}
                    >
                        <i className={`fa-solid ${isSyncRunning ? 'fa-spinner fa-spin' : 'fa-rotate'}`} />
                        Tout synchroniser
                    </button>
                </div>

                {/* Progress bar */}
                {syncProgress && (
                    <div style={{
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderLeft: `5px solid ${syncProgress.active ? '#3b82f6' : '#10b981'}`,
                        borderRadius: '8px',
                        padding: '14px 18px',
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <span style={{ fontSize: '13px', fontWeight: 700, color: '#1e293b' }}>
                                {syncProgress.active
                                    ? <><i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '8px', color: '#3b82f6' }} />Synchronisation en cours...</>
                                    : <><i className="fa-solid fa-circle-check" style={{ marginRight: '8px', color: '#10b981' }} />Terminée</>
                                }
                            </span>
                            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>
                                {syncProgress.completed} / {syncProgress.total}
                            </span>
                        </div>
                        <div style={{ width: '100%', height: '7px', background: '#e2e8f0', borderRadius: '4px', overflow: 'hidden', marginBottom: syncProgress.active ? '10px' : 0 }}>
                            <div style={{
                                width: `${percent}%`, height: '100%',
                                background: syncProgress.active
                                    ? 'linear-gradient(90deg, #3b82f6, #60a5fa)'
                                    : 'linear-gradient(90deg, #10b981, #34d399)',
                                transition: 'width 0.4s ease-out'
                            }} />
                        </div>
                        {syncProgress.active && syncProgress.currentName && (
                            <div style={{ fontSize: '12px', color: '#64748b', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <i className="fa-solid fa-spinner fa-spin" style={{ color: '#3b82f6', fontSize: '10px' }} />
                                En cours : <strong style={{ color: '#1e293b', marginLeft: '4px' }}>{syncProgress.currentName}</strong>
                            </div>
                        )}
                    </div>
                )}

                {/* Grid of sync cards */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                    gap: '12px'
                }}>
                    {SYNC_ITEMS.map(item => {
                        const s = itemStates[item.key];
                        const isLoading = s === 'loading';
                        const isOk      = s === 'ok';
                        const isError   = s === 'error';

                        return (
                            <div
                                key={item.key}
                                onClick={() => runSingle(item)}
                                style={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                    gap: '10px',
                                    padding: '20px 12px',
                                    background: isOk ? '#f0fdf4' : isError ? '#fef2f2' : '#fff',
                                    border: `1.5px solid ${isOk ? '#bbf7d0' : isError ? '#fecaca' : isLoading ? '#bfdbfe' : '#e2e8f0'}`,
                                    borderRadius: '10px',
                                    cursor: isSyncRunning ? 'not-allowed' : 'pointer',
                                    opacity: isSyncRunning && !isLoading ? 0.65 : 1,
                                    transition: 'box-shadow 0.2s, border-color 0.2s, background 0.2s',
                                    boxShadow: isLoading ? '0 0 0 3px #bfdbfe55' : '0 1px 3px rgba(0,0,0,0.06)',
                                    textAlign: 'center',
                                    userSelect: 'none',
                                }}
                                className="bexio-sync-card"
                            >
                                {/* Status / icon */}
                                <div style={{
                                    width: '38px', height: '38px',
                                    borderRadius: '50%',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    background: isOk ? '#dcfce7' : isError ? '#fee2e2' : isLoading ? '#dbeafe' : '#f1f5f9',
                                    fontSize: '16px',
                                    color: isOk ? '#16a34a' : isError ? '#dc2626' : isLoading ? '#3b82f6' : '#64748b',
                                    transition: 'background 0.2s, color 0.2s'
                                }}>
                                    <i className={`fa-solid ${isLoading ? 'fa-spinner fa-spin' : isOk ? 'fa-check' : isError ? 'fa-xmark' : item.icon}`} />
                                </div>

                                <span style={{ fontSize: '13px', fontWeight: 600, color: '#1e293b', lineHeight: '1.3' }}>
                                    {item.name}
                                </span>

                                {isError && (
                                    <span style={{ fontSize: '11px', color: '#dc2626' }}>Erreur — réessayer</span>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* Global success message */}
                {globalMessage && (
                    <div style={{ fontSize: '14px', color: '#16a34a', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fa-solid fa-circle-check" />
                        {globalMessage}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BexioUpdate;
